import { useCallback, useEffect, useState } from 'react';
import { Style } from '../react/types/style';
import api from './api';
import sources from './sources';
import useGym from './use_gym';
import { WithCollectionMeta } from 'react/types/collection_meta';

interface UseStyles {
  styles: WithCollectionMeta<Style>;
  setStyles: (styles: Style[]) => void;
  reloadStyles: () => void;
}

interface UseStylesParams {
  slim?: boolean;
}

const useStyles = ({ slim }: UseStylesParams = { slim: true }): UseStyles => {
  const gym = useGym();
  const [styles, setStyles] = useState<Style[]>([]);

  const reloadStyles = useCallback(() => {
    if (gym.is_martial_arts) {
      api.get(sources.styles(gym.id), { count: 1000, slim: slim ? 1 : undefined }).then((data) => {
        setStyles(data);
      });
    }
  }, [gym.id, gym.is_martial_arts, slim]);

  useEffect(() => {
    reloadStyles();
  }, [reloadStyles]);

  return { styles, setStyles, reloadStyles };
};

export default useStyles;
